import React, { PropTypes } from 'react';
import SectionText from '../../presentational/SectionText';

import data from '../../../core/data';

const WhatIsBPeel = (props) => {
  const intro = data.phyto.intro;
  return (
    <section className="image-bg" id="what-is-bpeel">
      <div className="container-fluid">
        <div className="box jumbotron">
          <h1 className="header">What is the BPeel™?</h1>
          <p>{ intro }</p>
        </div>
      </div>
    </section>
  )
}

export default WhatIsBPeel;



/** WEBPACK FOOTER **
 ** ./src/components/containers/bpeel/WhatIsBPeel.jsx
 **/